import { SmoothZoomInOptions } from "../types/mapUtils.type";

export const smoothZoomIn = async ({
  map,
  initialZoom,
  finalZoom,
}: SmoothZoomInOptions) => {
  return new Promise<void>(async (resolve) => {
    for (let zoom = initialZoom; zoom <= finalZoom; zoom++) {
      map.setZoom(zoom);
      await new Promise(res => setTimeout(res, 100));
    }

    return resolve();
  });
};
